import { DocumentAccessRequesterType } from "./DocumentSigner.dto";
import { DocsPdfMetainfo } from "./pdf/DocsPdf.dto";
import { Paginatable } from "../common/Paginatable.dto";

export enum DocumentContentType {
  Text = "TEXT",
  PDF = "PDF", // Deprecated
  MsWord = "MS_WORD",
  MsExcel = "MS_EXCEL",
  MsPowerPoint = "MS_PPT",
  DocsPdf = "DOCS_PDF",
  Proposal = "PROPOSAL",
  Unknown = "UNKNOWN",
}

export interface DocumentBase {
  id: bigint;
  title: string;
  version: string;
  convertRequestUuid?: string;
}

export interface DocsPdfDocument extends DocumentBase {
  contentType: DocumentContentType.DocsPdf;
  docsPdfId: bigint;
  metainfo: DocsPdfMetainfo;
}

// Deprecated
export interface PdfDocument extends DocumentBase {
  contentType: DocumentContentType.PDF;
  contentUrl: string;
}

export interface MsWordDocument extends DocumentBase {
  contentType: DocumentContentType.MsWord;
  contentUrl: string;
}

export interface MsExcelDocument extends DocumentBase {
  contentType: DocumentContentType.MsExcel;
  contentUrl: string;
}

export interface MsPowerPointDocument extends DocumentBase {
  contentType: DocumentContentType.MsPowerPoint;
  contentUrl: string;
}

export interface TextDocument extends DocumentBase {
  contentType: DocumentContentType.Text;
  content: string;
}

export interface UnknownDocument extends DocumentBase {
  contentType: DocumentContentType.Unknown;
  contentUrl?: string;
  content?: string;
}

export type Document =
  | DocsPdfDocument
  | PdfDocument
  | MsWordDocument
  | MsExcelDocument
  | MsPowerPointDocument
  | TextDocument
  | UnknownDocument;
export type DocumentResource = Document & {
  createdAt: Date;
};

export interface DocumentSummary {
  id: bigint;
  title: string;
  version: string;
  contentType: DocumentContentType;
  convertRequestUuid?: string;
}

export interface PaginateDocumentsRequest {
  folderId: bigint;
  page: number;
  rpp: number;
}

export type PaginateDocumentsResponse = Paginatable<DocumentResource>;

export interface CreateDocumentBaseRequest {
  folderId: bigint;
  title: string;
  version: string;
}

export interface CreateTextDocumentRequest extends CreateDocumentBaseRequest {
  contentType: DocumentContentType.Text;
  content: string;
}

export interface CreatePdfDocumentRequest extends CreateDocumentBaseRequest {
  contentType: DocumentContentType.DocsPdf;
  contentFileKey: string;
  contentFileName: string;
}

export interface CreateDocumentResponse {
  document: DocumentResource;
}

export interface GetDocumentById {
  documentId: bigint;
}

export type GetDocumentRequest = GetDocumentById;

export interface GetDocumentResponse {
  document: DocumentResource;
}

export interface DocumentAccessRequest {
  timezoneOffset: number;
  documentSignId?: bigint;
  signerToken?: string;
  documentSignAccessToken?: string;
  documentAccessRequesterType?: DocumentAccessRequesterType;
}

export interface TokenBasedAccessRequest {
  signerToken: string;
  documentSignAccessToken: string;
  documentAccessRequesterType: DocumentAccessRequesterType;
  timezoneOffset: number;
}
